
import store from "@/store/index";
import { uploadNote } from "@/api/aio";
import { registerFnHandler } from "@/utils/registerFnHandler";
import {
  onBeforeMount,
  onMounted,
  ref,
  reactive,
  computed,
  inject,
  watch,
  onUnmounted,
  onActivated,
  onDeactivated,
} from "vue";
import { useRoute, useRouter } from "vue-router";
import {
  nativeToast,
  playVideo,
  takeResources,
  getClientCommonMessage,
  getStatusBarInfo,
  nativeGoBack,
  previewResources,
  nativeUploadResources,
} from "@/utils/nativeFn";
import { compareVersion } from "@/utils/compareVersion";
import { v4 as uuidv4 } from "uuid";
import ActionBar from "../../components/ActionBar/index.vue";
import AioConfirm from "@/components/Aio/AioConfirm.vue";
import UploadProgress from "@/components/Aio/star3/UploadProgress.vue";

export default {
  components: {
    ActionBar,
    AioConfirm,
    UploadProgress,
  },
  setup() {
    const $xesLog = inject("$xesLog") as any; // 埋点
    const actionBarInfo = reactive({}); // actionBar需要的参数
    const uploadUuid = ref("");
    let statusBarHeight = ref(0); // 状态栏高度
    let actionBarHeight = ref(79); // 默认actionBar高度
    let noteList = computed(() => store.getters["star3NoteList"]);
    // 三星卡牌笔记部分
    const maxUpLoadNum = computed(() => store.getters["star3Note/max_upload_num"]);
    const callUploadActionVisible = ref(false);
    const callUploadActions = [
      { name: "拍照", type: "camera" },
      { name: "从相册选择", type: "library", className: "actionSheetItem" },
    ];
    let isSubmit = false;
    const confirmVisible = ref(false);
    const confirmInfo = reactive({});
    const confirmReUploadVisible = ref(false);
    const confirmReUploadInfo = reactive({});
    let {
      column_id,
      card_id,
      unicode,
      sku_name,
      sku_unid = "",
      cardName = "",
      isFromEdit,
      cardType = "2",
      progress,
      source_location = "",
    } = useRoute().query || {};

    const task_card_type = cardType === "1" ? "无星" : "3星";
    const reportDataMap = {
      page_name: "notes_modify",
      task_card_type,
      sku_name,
      card_name: cardName,
      sku_unid,
    };
    /**
     * 上传数据相关
     */
    const totalUpload = ref(0);
    const uploadedNum = ref(0);
    const uploadedFailNum = ref(0);
    const uploadProgressVisible = ref(false);
    // 取消上传
    const cancelUpload = (type = "") => {
      uploadUuid.value = "";
      if (type === "done") {
        upload();
      } else if (type === "fail") {
        nativeToast("该笔记存在未上传成功的图片，请全部上传成功后再提交～");
        uploadProgressVisible.value = false;
      } else {
        uploadProgressVisible.value = false;
      }
      uploadErrorFlag.value = false;
    };
    const uploadErrorFlag = ref(false);
    const uploadDataFn = (index) => {
      totalUpload.value = 0;
      uploadedNum.value = 0;
      uploadProgressVisible.value = true;
      let data = [];
      uploadUuid.value = uuidv4().replaceAll("-", "");
      const indexStr = typeof index === "number" ? `${uploadUuid.value}-${index}` : "";
      if (indexStr) {
        uploadErrorFlag.value = true;
        data.push({ ...getFormatData(noteList.value[index]), index: indexStr });
        totalUpload.value = 1;
        uploadedNum.value = 0;
      } else {
        noteList.value.forEach((item, index) => {
          let tile = getFormatData(item);
          (item.type !== "urlStr" || !item.resource.includes("http")) &&
            data.push({
              index: `${uploadUuid.value}-${index}`,
              ...tile,
              type: "uriStr",
            });
        });
        totalUpload.value = noteList.value.length;
        uploadedNum.value = noteList.value.length - data.length;
      }
      uploadedFailNum.value = 0;
      if (data.length) {
        nativeUploadResources({
          from: "star3",
          data,
        });
      }
    };
    const doCloseReUpload = () => {
      console.log("close");
      confirmReUploadVisible.value = false;
      $xesLog.track("notes_submit_popup_click", {
        ...reportDataMap,
        biz_name: "card_tasks",
        event_name: "笔记提交确认弹窗点击",
        button_name: "取消",
        event_type: "click",
      });
    };
    const doConfirmReUpload = (index) => {
      confirmReUploadVisible.value = false;
      uploadDataFn(index);
      $xesLog.track("notes_submit_popup_click", {
        ...reportDataMap,
        biz_name: "card_tasks",
        event_name: "笔记提交确认弹窗点击",
        button_name: "确认",
        event_type: "click",
      });
    };
    // 客户端上传数据
    const uploadResources = (index) => {
      if (!noteList.value.length) {
        nativeToast("上传内容不能为空");
        return;
      }
      $xesLog.track("notes_edit_click", {
        ...reportDataMap,
        button_name: '提交笔记',
        event_name: '笔记编辑页点击',
        source_location
      });
      if (progress == "3") {
        nativeToast("笔记已审核通过，无需上传笔记");
      } else {
        if (isFromEdit == "true" && typeof index !== "number") {
          Object.assign(confirmReUploadInfo, {
            title: "确定重新提交？",
            subTitle: "提交后笔记将重新开始审核",
            cancelText: "取消",
            confirmText: "确定",
            doClose: doCloseReUpload,
            doConfirm: doConfirmReUpload,
          });
          confirmReUploadVisible.value = true;
          $xesLog.track("notes_submit_popup_show", {
            biz_name: "card_tasks",
            page_name: "notes_modify",
            event_name: "笔记提交确认弹窗曝光",
            event_type: "click",
            task_card_type: "3星",
            sku_name,
            sku_unid,
            card_name: cardName,
          });
        } else {
          uploadDataFn(index);
        }
      }
    };
    // 处理上传进度
    const handleProgress = (res) => {
      console.log(res, "进度信息");
      let { from = "", resource, index, status, message = "" } = res || {};
      if (!(uploadUuid.value && index && index.includes(uploadUuid.value))) {
        return false;
      }
      index = index.split(`${uploadUuid.value}-`)?.[1];
      if (status === "0") {
        uploadedNum.value = uploadedNum.value + 1;
      } else {
        uploadedFailNum.value = uploadedFailNum.value + 1;
      }
      let type = status === "0" && resource.includes("http") ? "urlStr" : "uriStr";
      if (from === "star3") {
        noteList.value.splice(index, 1, {
          ...noteList.value[index],
          resource,
          status,
          message,
          type,
        });
      }
    };
    const upload = () => {
      // console.log(noteList.value, "即将上传的内容");
      let uploadData = {
        column_id,
        card_id,
        unicode,
        resource: [],
      };

      noteList.value.forEach((item) => {
        uploadData.resource.push(item.resource);
      });
      // console.log(uploadData, "uploadData");
      uploadNote(uploadData)
        .then((res) => {
          if (res.data.code === 0) {
            nativeToast("笔记上传成功");
            localStorage.setItem("firstUploadNoteSuccess", "1");
            // 跳转笔记页
            doBack();
          } else if (res.data.code === 102008) {
            nativeToast("笔记已审核通过，无需上传笔记");
            // 跳转笔记页
            doBack();
          } else {
            nativeToast("笔记上传失败，请重试");
          }
          uploadProgressVisible.value = false;
        })
        .catch((err) => {
          uploadProgressVisible.value = false;
        });
    };
    const deleteItem = (index) => {
      // console.log(index, "index");
      store.commit("DELETE_STAR3_NOTE", ["star3NoteList", index]);
      $xesLog.track("notes_edit_click", {
        ...reportDataMap,
        button_name: "删除",
        event_name: "笔记编辑页点击",
        source_location,
      });
      // console.log(store.getters["star3NoteList"], "store star3NoteList");
    };
    // 调起上传actionsheet
    const callUploadAction = () => {
      callUploadActionVisible.value = true;
      // 上传笔记方式弹窗曝光
      $xesLog.track("notes_upload_choose_popup_show", {
        ...reportDataMap,
        event_name: "上传笔记方式弹窗曝光",
      });
      $xesLog.track("notes_edit_click", {
        ...reportDataMap,
        button_name: "添加",
        event_name: "笔记编辑页点击",
        source_location,
      });
      // console.log("open--", callUploadActionVisible.value);
    };
    // 处理上传actionsheet的选中
    const handleSelectUploadAction = (item) => {
      // console.log('-----------card_id',maxUpLoadNum.value[card_id + ''])
      // console.log(useRoute().query,'useRoute().query')
      // console.log(maxUpLoadNum.value,card_id,'maxUpLoadNum.value.card_id')
      // console.log((maxUpLoadNum.value.card_id || 6) - noteList.value.length,'(maxUpLoadNum.value.card_id || 6) - noteList.value.length')
      
      callUploadActionVisible.value = false
      takeResources({
        type: item.type,
        maxCount: (maxUpLoadNum.value[card_id + ""] || 6) - noteList.value.length,
        sourceType: "image",
        from: "star3",
      });
      $xesLog.track("notes_upload_choose_button_click", {
        ...reportDataMap,
        button_name: item.name || "",
        popup_location: "知识点详情页上传按钮",
        event_name: "内容编辑页添加按钮",
      });
    };

    const handleUploadActionCancel = () => {
      $xesLog.track("notes_upload_choose_button_click", {
        ...reportDataMap,
        button_name: "取消",
        popup_location: "知识点详情页上传按钮",
        event_name: "内容编辑页添加按钮",
      });
    };
    const getFormatData = (item) => {
      let res = {};
      if (item.resource && /^http(s)?:/.test(item.resource)) {
        return {
          resource: item.resource,
          type: "urlStr",
        };
      } else if ((item.resource && !/^http(s)?:/.test(item.resource)) || item.uri) {
        return {
          resource: item.uri,
          type: "uriStr",
        };
      }
      return res;
    };
    const handlePreview = (index) => {
      let data = noteList.value.map((item) => {
        return getFormatData(item);
      });
      // console.log(data, "图片预览");
      previewResources({
        initIndex: index,
        data,
      });
    };
    // 端上回传图片列表
    const takeResourcesCallback = (data) => {
          console.log('===选择的资源信息====2', JSON.stringify(data))
      data = data.map((item) => {
        return {
          ...item,
          base64: `data:image/gif;base64,${item.resource}`,
          type: "uriStr",
        };
      });
      store.commit("CONCAT_STAR3_NOTELIST", ["star3NoteList", data]);
      // console.log(store.getters["star3NoteList"], "store star3NoteList");
    };
    // 初始化弹窗
    const initActionBar = () => {
      Object.assign(actionBarInfo, {
        actionBarTitle: "我的笔记",
        actionBarBg: "#fff",
      });
    };
    // 获取状态栏高度
    const getStatusBarHeight = () => {
      getStatusBarInfo({}, (res) => {
        // console.log("h5调用端上getStatusBarInfo", res); // app返回给前端的值
        statusBarHeight.value = res.height;
        actionBarHeight.value = 44 + res.height || 35;
      });
    };
    const goback = (type = "") => {
      console.log("调用端返回");
      Object.assign(confirmInfo, {
        subTitle: "笔记还未提交，确定现在返回？",
        cancelText: "取消",
        confirmText: "确定",
        doClose,
        doConfirm,
      });
      confirmVisible.value = true;
      $xesLog.track("notes_modify_cancel_popup_show", {
        biz_name: "card_tasks",
        page_name: "notes_modify",
        event_name: "笔记编辑挽留弹窗曝光",
        event_type: "click",
        task_card_type,
        sku_name,
        sku_unid,
        card_name: cardName,
      });
    };
    const doBack = () => {
      clearStateObj();
      nativeGoBack({}, (res) => {
        // console.log("h5调用端上nativeGoBack", res); // app返回给前端的值
      });
    };
    // 清楚状态数据
    const clearStateObj = () => {
      store.commit("SET_STAR3_NOTELIST", ["star3NoteList", []]);
    };
    const doClose = () => {
      console.log("close");
      confirmVisible.value = false;
      $xesLog.track("", {
        ...reportDataMap,
        button_name: "取消",
        event_name: "笔记编辑挽留弹窗点击",
      });
    };
    const doConfirm = () => {
      console.log("doConfirm");
      confirmVisible.value = false;
      $xesLog.track("notes_modify_cancel_popup_click", {
        ...reportDataMap,
        button_name: "确认",
        event_name: "笔记编辑挽留弹窗点击",
      });
      doBack();
    };
    const getClientCommonMessageFn = () => {
      // 初始化弹窗
      initActionBar();
      // 获取状态栏高度 + 计算actionBar高度
      getStatusBarHeight();
    };
    onMounted(() => {
      localStorage.setItem("firstUploadNoteSuccess", "");
      getClientCommonMessageFn();
      // console.log(noteList.value, "noteList");
      // 注册选择图片的回调
      registerFnHandler("takeResourcesCallback", (res) => {
        const { from = "", data = "[]", sourceType = "" } = res || {};
        try {
          takeResourcesCallback(typeof data === "string" ? JSON.parse(data) : data);
        }catch(err) {
          console.log(err)
        }
      });

      // 图片上传进度回调
      registerFnHandler("uploadResourceCallBack", (res = {}) => {
        handleProgress(res);
      });
      $xesLog.track("page_view", {
        ...reportDataMap,
        event_name: "笔记编辑页浏览",
      });
    });

    return {
      noteList,
      upload,
      deleteItem,
      callUploadAction,
      handleSelectUploadAction,
      handleUploadActionCancel,
      takeResourcesCallback,
      totalUpload,
      uploadedNum,
      uploadedFailNum,
      uploadProgressVisible,
      callUploadActions,
      callUploadActionVisible,
      uploadErrorFlag,
      actionBarInfo,
      actionBarHeight,
      goback,
      confirmVisible,
      confirmInfo,
      handlePreview,
      uploadResources,
      cancelUpload,
      confirmReUploadInfo,
      confirmReUploadVisible,
      maxUpLoadNum,
      card_id,
    };
  },
};
